module.exports = __webpack_public_path__ + "static/out-of-office-df2911a65cc98f7b15f5e982812a4b61.jpg";